import { useContext } from 'react';
import { DisplayFrameworkContext } from '../context/DisplayFrameworkContext';

export function useDisplayFrameworkContext() {
  return useContext(DisplayFrameworkContext);
}
